import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { FaSearch } from 'react-icons/fa'
import CreateShelfModal from '../Components/CreateShelfModal'
import Input from '../Components/Input'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { ConfirmPickUp, GetAllProductShelf, ReadAllRequest, ReadAllRequestDeviceAssignment } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import PrintPickUp from './PrintPickUp'
import { configuration } from '../Utils/config'
import UpdateQty from '../Components/UpdateQty'
import UpdatePickUpQty from '../Components/UpdatePickUpQty'

export default function DeviceAssignmentRequest() {
    const { isOpen, onOpen, onClose } = useDisclosure();


    const [ModelState, setModelState] = useState(false);
    const [PrintMode, setPrintMode] = useState(false);

    const [SearchText, setSearchText] = useState("");
    const [SingleData, setSingleData] = useState(false);

    const [Data, setData] = useState([]);
    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const [PreLoader, setPreLoader] = useState(true);

    const [OpenModal, setOpenModal] = useState(false);


    //get current post

    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentData = Data.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }
    const [Result, setResult] = useState([]);
    const [TotalData, setTotalData] = useState([]);
    const [TransferId, setTransferId] = useState("");




    const GetAllRequest = async () => {
        let result = await ReadAllRequestDeviceAssignment()

        console.log("result request", result);

        if (result.status === true) {
            setData(result.queryresult.allrequest)
            setTotalData(result.queryresult.totalallrequest)
            setPreLoader(false)
        }
    }





    const PickUpBtn = async (id) => {
        try {

            let result = await ConfirmPickUp(id);
            console.log("result", result);
            setModelState(!ModelState)

        } catch (e) {


        }
    }

    const Print = (id) => {

        let singleInfo = Data.filter((item, i) => {
            return item._id === id
        })
        setPrintMode(true)
        setSingleData(singleInfo)

    }



    const editQty = (id) => {

        let singleInfo = Data.filter((item, i) => {
            return item._id === id
        })
        setOpenModal(true)
        setSingleData(singleInfo)
    }


    useEffect(() => {
        GetAllRequest()
    }, [isOpen, ModelState, OpenModal]);
    return (

        <MainLayout>
         {
                PreLoader && (

                    <Preloader />
                )
            }
            <Seo title="Pick up" description='EKO IMS - Pick up' />
            <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"} >


                <Text textTransform="capitalize">Total Product Request - {TotalData}</Text>

            </Flex>


            <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"TicketNo, StaffId, StaffMail, ProductName, ProductShelf"} />
            <Box height="70vh" minH={"70vh"} overflow="scroll" w="100%" _hover={{ overflow: "auto" }} bg="blue.blue300" mt="32px" rounded={"8px"}>

                <TableContainer mt="32px" overflowX="auto" color="#fff">

                    <Table variant='simple' size='sm' >
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Device Serial No</Th>
                                <Th color="#fff">TicketNo</Th>
                                <Th color="#fff">Name</Th>
                                <Th color="#fff">Qty Requested</Th>
                                <Th color="#fff">Store</Th>
                                <Th color="#fff">staffEmail</Th>
                                <Th color="#fff">department</Th>                
                                <Th color="#fff">for device_assignment</Th>
                                <Th color="#fff">Request Date</Th>
                             



                            </Tr>
                        </Thead>


                        <Tbody>
                            {
                                SearchText === "" ? (
                                    currentData.map((item, i) => (
                                        <TableRow
                                            type={"device assignment request"}
                                            key={i}
                                            sn={i + 1}
                                            serialNo={item.deviceserialnumber}
                                            ticketNo={item.ticket}
                                            productName={item.productkey.productname}
                                            qty={item.qtyrequested}
                                            store={item.store}
                                            StaffChangeQty={item.staffchangeqty}
                                            staffemail={item.staffemail}
                                            dept={item.department}
                                            staffId={item.staffid}
                                            status={item.status}
                                            isDeviceAssignment={item.fordeviceassignment}
                                            dateReceived={moment(item.requestdate).format('DD/MM/YYYY')}
                                           
                                        />
                                    ))
                                ) : (
                                    SearchText !== "" && Data.filter(item => item.ticket?.includes(SearchText) || item.productshelf?.includes(SearchText) || item.staffid?.includes(SearchText) || item.productname?.toLowerCase().includes(SearchText.toLowerCase()) || item.staffemail?.includes(SearchText)).length > 0 ? (

                                        Data.filter(item => item.ticket?.includes(SearchText) || item.productshelf?.includes(SearchText) || item.productname?.toLowerCase().includes(SearchText.toLowerCase()) || item.staffid?.includes(SearchText) || item.staffemail?.includes(SearchText)).

                                            map((item, i) => (
                                                <TableRow
                                                    type={"device assignment request"}
                                                    key={i}
                                                    sn={i + 1}
                                                    serialNo={item.deviceserialnumber}
                                                    ticketNo={item.ticket}
                                                    productName={item.productname}
                                                    qty={item.qtyrequested}
                                                    qtyControlled={item.qtycontrol}
                                                    StaffChangeQty={item.staffchangeqty}
                                                    staffemail={item.staffemail}
                                                    dept={item.department}
                                                    staffId={item.staffid}
                                                    status={item.status}
                                                    isDeviceAssignment={item.fordeviceassignment}
                                                    dateReceived={moment(item.requestdate).format('DD/MM/YYYY')}
                                                    onClick={() => PickUpBtn(item._id)}
                                                    print={() => Print(item._id)}
                                                />
                                            ))
                                    ) : (
                                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>

                                    )

                                )


                            }
                        </Tbody>

                    </Table>
                </TableContainer>

                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />
                <UpdatePickUpQty SingleData={SingleData} state="request" isOpen={OpenModal} onClose={() => setOpenModal(false)} />



            </Box>

        </MainLayout>
    )
}
